// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * OHT Weather Widget - React Version
 * Main stylesheet
 */

.oht-weather-widget {
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2px;
  color: #333;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #fff;
  padding-bottom: 43px;
}

.oht-weather-widget.no-border {
  border: none;
  box-shadow: none;
  border-radius: 0;
}

/* Loading State */
.weather-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  text-align: center;
}

.loading-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px; /* Give it some height so spinner is visible */
  width: 100%;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #000; /* Black spinner */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Weather Header */
.weather-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  margin-top: 5px;
  padding-left: 10px;
  padding-right: 4px;
}

.weather-header-link {
  display: block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.location {
  display: flex;
  align-items: center;
}

.location h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.location-pin {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  color: #000000;
  margin-top:-5px;
}

.weather-search form {
  display: flex;
}

.weather-search input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
  font-size: 14px;
}

.weather-search button {
  padding: 8px 12px;
  background-color: #000000;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  font-size: 14px;
}

.weather-search button:hover {
  background-color: rgb(42, 42, 42);
}

/* Current Weather */
.current-weather {
  display: flex; /* Use flex */
  flex-wrap:wrap;
  gap: 20px; /* Gap between columns */
  align-items: flex-start; /* Align items to the top */
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 8px;
}
.weather-content{
  padding:3px;
}
.current-weather-container{
  flex: 1 1 300px;
}

/* Style the top part (icon + temp/condition) */
.current-weather-top {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 28px;
}

/* Larger main weather icon */
.current-weather-top > .weather-icon.large-icon {
  font-size: 84px; /* Make icon larger */
  padding-left: 20px
}

.temp-condition {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align text left */
  text-align: left;
  margin-left: 41px;
}

/* New style for RIGHT NOW label */
.right-now-label {
  font-size: 12px;
  font-weight: bold;
  color: #666;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.temperature {
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
  display: flex; /* Align icon and temp */
  align-items: center;
}

.condition {
  font-size: 18px;
  margin-top: 5px;
  color: #666;
}

.weather-details {
  display: grid; /* Use grid for two columns */
  grid-template-columns: 1fr 1fr; /* Two equal columns */
  gap: 5px 20px; /* Row gap, Column gap */
}

.detail-item {
  display: flex; /* Label and value side-by-side */
  justify-content: space-between; /* Push label and value apart */
  align-items: center;
  min-width: 0; /* Allow shrinking */
  padding-bottom: 5px;
  border-bottom: 1px solid #eee; /* Add border below each item */
}
.detail-item:nth-last-child(-n+2) { /* Remove border from last row */
  border-bottom: none;
}

.detail-label {
  font-size: 14px; /* Slightly smaller label */
  color: #333;
  margin-bottom: 0;
  margin-right: 10px; /* Space between label and value */
  font-weight: bold; /* Make label bold */
}
.today-forecast-box {
  border-radius: 8px;
  padding: 16px;
  margin-top: 5px;
  margin-left: 10px;
  border-left: 1px solid #eee;
  flex: 1 1 300px;
}

.today-forecast-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.today-forecast-description {
  font-size: 14px;
  margin-bottom: 16px;
  color: #555;
  line-height: 1.4;
}

.today-forecast-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tonight-forecast,
.tomorrow-forecast {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.forecast-period {
  font-weight: 600;
  font-size: 15px;
  color: #444;
}

.forecast-text {
  font-size: 14px;
  color: #555;
  line-height: 1.4;
}
.detail-value {
  font-size: 14px; /* Match label size */
  font-weight: normal; 
  text-align: right; /* Align value to the right */
  white-space: nowrap; /* Prevent wrapping */
}

/* Weather Tabs */
.weather-tabs {
  margin-top: 20px;
}

.tab-buttons {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}

.tab-buttons button {
  padding: 10px 20px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s, border-bottom 0.2s;
  color: #000;
}

.tab-buttons button.active {
  opacity: 1;
  border-bottom: 3px solid #0066cc;
  font-weight: 600;
}

.tab-buttons button:hover {
  opacity: 0.9;
}

.tab-content {
  animation: fadeIn 0.3s ease-in;
  display: block;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Hourly Forecast */
.hourly-heading {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: normal;
}

.hourly-forecast-table {
  width: 100%;
  border-collapse: collapse;
}

.hourly-forecast-table th {
  text-align: left;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #000;
  border-bottom: 1px solid #eee;
  text-transform: uppercase;
}
.hourly-forecast-table tr {
  border-bottom: 1px solid #eee;
}
.hourly-forecast-table td {
  padding: 12px 10px;
}
.hourly-forecast-table tr:hover {
  background-color: #f5f9ff;
}

.detail-btn {
  text-align: right;
}å
.detail-circle i{
    color: #000;
}
.detail-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color:#000;
  border: none;
  background-color: #f5f5f5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.detail-circle:hover {
  background-color: #e5e5e5;
}

/* 7 Day Forecast */
.seven-day-forecast-table {
  width: 100%;
  border-collapse: collapse;
}


.seven-day-forecast-table th {
  text-align: center;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #000;
  border-bottom: 1px solid #eee;
}

.seven-day-forecast-table td {
  padding: 12px 10px;
  border-bottom: 1px solid #eee;
}
.seven-day-forecast-table tr:hover {
  background-color: #f5f9ff;
}

.seven-day-forecast-table td.day-name {
  width: 60px; /* Narrower day column */
  white-space: nowrap;
}

.seven-day-forecast-table td.temp-range {
  width: auto; /* Allow temp column to take remaining space */
}

.seven-day-forecast-table td.detail-btn {
  width: 1%; /* Make last column narrow */
  white-space: nowrap;
  text-align: right; /* Align button to the right */
}

.seven-day-forecast-table td.precip {
  width: 100px; /* Narrower precip and icon columns */
  text-align: center; /* Center content */
}
.seven-day-forecast-table td.weather-icon {
  width: 150px; /* Narrower precip and icon columns */
  text-align: center; /* Center content */
  font-size: 24px;
}
.day-name {
  font-weight: 600;
}

.weather-icon {
  text-align: center;
}

.icon-container {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}


.precip i {
    margin-right: 5px;
}
.temp-bar {
  display: flex;       /* Use flex for alignment */
  align-items: center; 
  justify-content: center; /* Center the slider */
  gap: 5px;            /* Add small gap between elements */
  position: relative;  
  width: 100%; /* Ensure bar takes full width of cell */
}

.temp-slider {
  /* No flex needed */
  height: 28px;
  background: linear-gradient(to right, #d9e7f3, #5a8db6);
  position: relative;  /* Position relative for absolute children */
  border-radius: 11px;
  margin: 0 auto; /* Center the slider within the bar */
}

.low-temp, .high-temp {
  font-size: 14px;
  font-weight: 600;
  position: absolute;  /* Absolute positioning */
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  z-index: 1;
}

.low-temp {
  left: 8px;
  color:#042743;       /* Dark blue text */
}

.high-temp {
  right: 8px;
  color: #fff;         /* White text */
}

/* Mobile-specific temp display - hidden by default */
.temp-range-mobile {
  display: none; /* Hide this cell by default */
}

.temp-text-mobile {
  display: none; /* Hide text by default */
  font-size: 14px;
  font-weight: 600;
  color: #042743;
  text-align: center;
  white-space: nowrap;
}

/* Weather Map */
.map-tab {
  position: relative;
}

.radar-controls {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.radar-locations button, 
.radar-layers button {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.radar-locations button:hover,
.radar-layers button:hover {
  background-color: #f5f5f5;
}

.radar-layers {
  display: flex;
  gap: 5px;
}

.weather-map {
  width: 100%;
  background-color: #f0f0f0;
  border-radius: 4px;
  position: relative;
}

.map-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  color: #666;
}

.map-timestamp {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 12px;
  color: #888;
}

.map-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.legend-scale {
  width: 100px;
  height: 10px;
  background: linear-gradient(to right, #0066ff, #00ff00, #ffff00, #ff9900, #ff0000);
  border-radius: 2px;
}

.legend-labels {
  width: 100px;
  display: flex;
  justify-content: space-between;
}

/* Weather Detail Modal */
.weather-detail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.modal-header {
  padding: 16px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.close-button:hover {
  color: #000;
}

.modal-body {
  padding: 16px;
}

.detail-overview {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.detail-temps {
  font-size: 16px;
  margin-bottom: 8px;
}

.detail-temps .high {
  color: #d9534f;
  font-weight: bold;
}

.detail-temps .low {
  color: #5bc0de;
  font-weight: bold;
  margin-top: 4px;
}

.detail-condition {
  flex: 1;
  min-width: 200px;
}

.detail-condition h4 {
  margin: 0 0 8px 0;
  color: #333;
}

.detail-condition p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.detail-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-section {
  background-color: #f9f9f9;
  border-radius: 6px;
  padding: 12px;
}

.detail-section h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #444;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 14px;
}

.detail-row .label {
  color: #666;
}

.detail-row .value {
  font-weight: 500;
  color: #333;
}

.detail-day-night {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.detail-day-night .day,
.detail-day-night .night {
  flex: 1;
  min-width: 200px;
}

.detail-day-night .day h4 {
  color: #f0ad4e;
}

.detail-day-night .night h4 {
  color: #5bc0de;
}

.detail-section.astro .detail-row {
  margin-bottom: 8px;
}

@media (max-width: 600px) {
  .modal-content {
    width: 95%;
  }
  
  .detail-summary {
    flex-direction: column;
  }
  
  .detail-day-night {
    flex-direction: column;
    gap: 8px;
  }
  
  .detail-row {
    font-size: 13px;
  }
}

/* Responsive Styles */
@media (max-width: 768px) {
  .oht-weather-widget {
    padding: 11px;
  }
  
  .current-weather {
    gap: 20px;
  }
  
  .weather-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .weather-search form {
    width: 100%;
  }
  
  .weather-search input {
    flex: 1;
  }
  
  .today-forecast-details {
    flex-direction: column;
    gap: 15px;
  }
  
  .tonight-forecast, .tomorrow-forecast {
    width: 100%;
  }
  
  .tab-buttons button {
    padding: 8px 12px;
    font-size: 14px;
  }
  
  .detail-row {
    flex-direction: column;
    gap: 8px;
  }
  
  .detail-item {
    flex-direction: row;
    justify-content: space-between;
    min-width: auto;
  }

  /* Show mobile temp text, hide temp bar */
  .seven-day-forecast-table td.temp-range {
    display: none; /* Hide original temp bar column */
  }
  .seven-day-forecast-table td.temp-range-mobile {
    display: table-cell; /* Show mobile temp text column */
  }
  .seven-day-forecast-table .temp-text-mobile {
    display: block; /* Show the mobile text */
  }
  .today-forecast-box{
    margin-left: 0px;
    border-left: unset;
    padding: 0px;
  }
}

/* 7 Day Forecast Expandable Rows */
.seven-day-forecast-table tr.expanded-row {
  background-color: #f5f9ff;
}

.seven-day-forecast-table .detail-circle.expanded svg {
  transform: rotate(90deg);
}

.seven-day-forecast-table .detail-circle svg {
  transition: transform 0.3s ease;
}

.details-row {
  background-color: #f5f9ff;
}

.day-details {
  padding: 15px;
  animation: slideDown 0.3s ease-in-out;
  overflow: hidden;
}

@keyframes slideDown {
  from { max-height: 0; opacity: 0; }
  to { max-height: 1000px; opacity: 1; }
}

.day-details-header {
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
}

.day-details-header h3 {
  margin: 0;
  font-size: 16px;
  color: #444;
}

.forecast-narrative {
  margin: 5px 0;
  font-size: 14px;
  font-style: italic;
  color: #666;
  line-height: 1.4;
}

.day-details-content {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

/* New grid layout for weather stats */
.weather-stats-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.stat-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  flex: 1;
  min-width: 250px;
}

.stat-box {
  display: flex;
  flex-direction: column;
  min-width: 100px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-left: 3px solid #4dabf7;
}

.stat-box:nth-child(2) {
  border-left-color: #fd7e14;
}

.stat-box:nth-child(3) {
  border-left-color: #20c997;
}

.stat-box:nth-child(4) {
  border-left-color: #7950f264;
}

.stat-label {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 15px;
  font-weight: 500;
  color: #343a40;
}

.high-value {
  color: #e03131;
}

.low-value {
  color: #1971c2;
}

/* Day/Night section */
.day-night-container {
  margin-top: 10px;
  background-color: white;
  border-radius: 6px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.section-title {
  margin: 0 0 12px 0;
  font-size: 15px;
  color: #495057;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

.day-night-columns {
  display: flex;
  gap: 20px;
}

.time-column {
  flex: 1;
  padding: 10px 15px;
  border-radius: 5px;
  background-color: #f8f9fa;
}

.day-column {
  border-left: 3px solid #fd7e14;
}

.night-column {
  border-left: 3px solid #1971c2;
}

.time-column h5 {
  margin: 0 0 10px 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.day-column h5 {
  color: #fd7e14;
}

.night-column h5 {
  color: #1971c2;
}

.time-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.time-detail {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-temp {
  font-size: 24px;
  font-weight: 600;
}

.detail-condition {
  font-size: 13px;
  color: #495057;
}

.mini-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 5px;
}

.mini-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  background-color: white;
  padding: 5px 8px;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  min-width: 70px;
}

.mini-label {
  font-size: 11px;
  color: #6c757d;
}

.mini-value {
  font-size: 13px;
  font-weight: 500;
  color: #343a40;
}

/* Responsive design */
@media (max-width: 600px) {
  .weather-stats-grid {
    flex-direction: column;
    gap: 10px;
  }
  
  .day-night-columns {
    flex-direction: column;
    gap: 15px;
  }
}

/* Condensed weather stats for 7-day forecast */
.weather-stats-condensed {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  min-width: 100px;
}

.stat-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.mini-stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
}

.mini-stat {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #555;
}

/* New detailed day layout */
.day-details-grid {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.day-summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.day-icon {
  margin-bottom: 5px;
}

.large-icon {
  font-size: 48px;
}

.day-temps {
  display: flex;
  align-items: center;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 10px;
}

.day-high-temp {
  color: #000;
}

.day-low-temp {
  color: #666;
  font-size: 28px;
}

.day-narrative {
  font-size: 14px;
  color: #555;
  line-height: 1.4;
  margin-top: 10px;
}

.weather-details-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.detail-item-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.detail-item-value {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.night-forecast-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 5px;
}

.night-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.night-description {
  font-size: 14px;
  line-height: 1.5;
  color: #444;
}

@media (max-width: 650px) {
  .day-details-grid {
    grid-template-columns: 1fr;
  }
  
  .day-summary {
    margin-bottom: 20px;
  }
}

/* Two-column layout for weather details */
.details-two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.details-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (max-width: 450px) {
  .details-two-column {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

/* Hourly forecast styling update */
.hourly-temp {
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 20px;
}
thead{
  background-color: ghostwhite;

}

.hourly-icon {
  font-size: 22px;
  margin-right: 5px;
}

.hourly-wind {
  text-align: left;
  white-space: nowrap;
}

.hourly-wind i {
  font-size: 22px;
  color: #555;
  margin-right: 5px;
}

.hourly-precip {
  white-space: nowrap;
}

.hourly-precip i {
  margin-right: 5px;
}

/* Hourly Forecast Expandable Details */
.hourly-forecast-table tr.expanded-row {
  background-color: #f5f9ff;
}

.hourly-forecast-table .detail-circle.expanded i {
  transform: rotate(90deg);
}

.hourly-forecast-table .detail-circle i {
  transition: transform 0.3s ease;
  color: #000;
}

.details-row {
  background-color: #f9f9fa;
}

.hourly-details {
  padding: 15px;
  animation: slideDown 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

}

.hourly-time-temp {
  text-align: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.hourly-time {
  font-size: 18px;
  font-weight: 600;
}

.hourly-temp-detail {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 32px;
}

.hourly-condition-name {
  font-size: 16px;
  color: #666;
}

.hourly-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
  /* border: 1px solid #eee; */
  overflow: hidden;
}

.hourly-detail-left, 
.hourly-detail-right {
  padding: 10px 15px;
}
.hourly-details-right-section {
  margin-left: 10px;
  border-left: 1px solid #eee;
}
.hourly-detail-left {
  border-right: 1px solid #eee;
}

.hourly-detail-left .detail-item-row,
.hourly-detail-right .detail-item-row {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border:unset;
  /* border-bottom: 1px solid #eee; */
}

.hourly-detail-left .detail-item-row:last-child,
.hourly-detail-right .detail-item-row:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.detail-item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.detail-item-row.uv-row {
  max-width: 250px;
  margin: 5px auto;
  padding: 8px 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.detail-item-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.detail-item-value {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

@media (max-width: 600px) {
  .hourly-details-grid {
    grid-template-columns: 1fr;
    gap: 5px;
  }
  
  .hourly-details-columns {
    flex-direction: column;
  }
  
  .hourly-detail-left {
    border-right: none;
    border-bottom: 1px solid #eee;
  }
}

/* Wind icon styling */
.wi-wind {
  font-size: 22px;
  display: inline-block;
}

.towards-0-deg {
  transform: rotate(0deg);
} 

.leaflet-attribution-flag{
  display: none !important;
}

/* Weather Alerts Styles */
.weather-alerts-container {
  margin-bottom: 15px;
  width: 100%;
}

/* Alert banner styling to match the red warning banner in the screenshot */
.weather-alert {
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 5px;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.weather-alert:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.weather-alert:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-bottom: 0;
}

.weather-alert .alert-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  position: relative;
}

.weather-alert:first-child .alert-header {
  background-color: #c41e3a;
  color: white;
}

.weather-alert:first-child .alert-headline {
  color: white;
  font-weight: 700;
}

.weather-alert .alert-icon {
  margin-right: 12px;
  font-size: 20px;
  flex-shrink: 0;
}

.weather-alert .alert-headline {
  flex-grow: 1;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.weather-alert .alert-toggle {
  margin-left: 8px;
  font-size: 12px;
  color: inherit;
  opacity: 0.7;
}

.weather-alert .alert-details {
  padding: 0 16px 16px;
  background-color: #f8f9fa;
  font-size: 14px;
  line-height: 1.5;
  border-top: 1px solid #eee;
}

.weather-alert .alert-meta {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  font-size: 13px;
  color: #666;
}

.weather-alert .alert-instructions h4,
.weather-alert .alert-description h4 {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
}

.weather-alert .alert-instructions p,
.weather-alert .alert-description p {
  margin: 0 0 16px;
  white-space: pre-line;
}

.weather-alert .alert-timing {
  font-size: 12px;
  color: #666;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.weather-alert .alert-timing p {
  margin: 4px 0;
}

/* Animation for expanded alert */
.weather-alert.expanded {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Winter storm watch specific styling to match screenshot */
.weather-alert[data-alert-type="winter-storm-watch"] .alert-header {
  background-color: #c41e3a;
  color: white;
}
.oht-sidebar .oht-weather-widget .oht-weather-container.in-widget .weather-content{
  padding: 0;
}

/* .oht-sidebar .oht-weather-widget .hourly-forecast-table th:last-child,
.oht-sidebar .oht-weather-widget .hourly-forecast-table td:last-child{
  display: none;
} */
/* hide wind icon column .hourly-forecasttable*/
.oht-sidebar .oht-weather-widget .hourly-forecast-table th:nth-child(3),
.oht-sidebar .oht-weather-widget .hourly-forecast-table td:nth-child(3){
  display: none;
}

/* for 7 day hide precip column */
.oht-sidebar .oht-weather-widget .seven-day-forecast-table th:nth-child(3),
.oht-sidebar .oht-weather-widget .seven-day-forecast-table td:nth-child(3){
  display: none;
}
.oht-sidebar .details-row .hourly-details, .oht-sidebar .details-row .day-details-content{
  display:grid;
}
.oht-sidebar .detail-circle{
  width:0px;
}
.oht-sidebar .hourly-details{
  padding: 0px;
  justify-content: unset;
}
.oht-sidebar .hourly-detail-left{
  border:unset;
  padding:0px;
}
.oht-sidebar .hourly-detail-right{
  padding:0px;
  border:unset;
}
.oht-sidebar .hourly-details-right-section{
  border:unset;
  margin-right:10px;
}
.oht-sidebar .details-row .hourly-details-grid, .oht-sidebar .details-row .day-details-grid{
  grid-template-columns: 1fr;
  border:unset;
  gap:0px;
}
/* for 7 day hide last column
.oht-sidebar .oht-weather-widget .seven-day-forecast-table th:last-child,
.oht-sidebar .oht-weather-widget .seven-day-forecast-table td:last-child{
  display: none;
} */
.oht-sidebar .today-forecast-box {
  border-radius: 8px;
  padding: 0px;
  margin:0px;
  border:unset;
}
.oht-sidebar .details-two-column{
  grid-template-columns: 1fr;
}
/* Show mobile temp text, hide temp bar in .oht-sidebar */
.oht-sidebar .seven-day-forecast-table td.temp-range {
  display: none; 
}
.oht-sidebar .seven-day-forecast-table td.temp-range-mobile {
  display: table-cell; 
}
.oht-sidebar .seven-day-forecast-table .temp-text-mobile {
  display: block; 
}
.oht-sidebar .current-weather{
  padding: 2px;
}
.oht-sidebar .weather-details{
  gap: 5px 12px;
}
.oht-sidebar .oht-weather-widget {
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.wi {
  font-weight: bold!important;
}

/* Ensure tab content allows centering */
.tab-content.hourly-tab,
.tab-content.forecast-tab {
  position: relative; /* Needed for absolute centering of spinner if used directly */
  /* Add padding or min-height if needed */
  padding: 20px;
}

/* Hide timeline controls on small screens */
@media (max-width: 500px) {
  /* Hide only the slider, keep the time display */
  .time-slider {
    display: none;
  }
  .timeline-container {
    /* Adjust layout now that slider is gone */
    flex-grow: 1; /* Allow it to take space */
    justify-content: center; /* Center the time display */
  }
  .time-display {
    width: auto; /* Allow time display to size naturally */
    text-align: center;
  }
  /* Optional: Adjust spacing of remaining controls if needed */
  .radar-controls.bottom-bar .timeline-controls {
    margin: 0 auto; /* Center play/prev/next buttons */
  }
  /* Hide only the text in the layers button */
  .layers-btn-text {
    display: none;
  }
  /* Adjust button padding if icon looks lonely */
  .radar-controls.bottom-bar .layers-btn {
    padding: 6px 8px; /* Reduce padding */
  }
  .tab-content.hourly-tab, .tab-content.forecast-tab {
    padding: 0px;
  }
  .tab-content.map-tab {
    margin-bottom: 42px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WeatherWidget.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAE,8CAA8C;EACjE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,uBAAuB,EAAE,kBAAkB;EAC3C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,aAAa,EAAE,aAAa;EAC5B,cAAc;EACd,SAAS,EAAE,wBAAwB;EACnC,uBAAuB,EAAE,2BAA2B;EACpD,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,eAAe,EAAE,qBAAqB;EACtC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,oBAAoB;EAC7C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa,EAAE,wBAAwB;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa,EAAE,6BAA6B;EAC5C,8BAA8B,EAAE,sBAAsB;EACtD,aAAa,EAAE,wBAAwB;AACzC;;AAEA;EACE,aAAa,EAAE,iCAAiC;EAChD,8BAA8B,EAAE,+BAA+B;EAC/D,mBAAmB;EACnB,YAAY,EAAE,oBAAoB;EAClC,mBAAmB;EACnB,6BAA6B,EAAE,+BAA+B;AAChE;AACA,oCAAoC,gCAAgC;EAClE,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,2BAA2B;EAC5C,WAAW;EACX,gBAAgB;EAChB,kBAAkB,EAAE,kCAAkC;EACtD,iBAAiB,EAAE,oBAAoB;AACzC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe,EAAE,qBAAqB;EACtC,mBAAmB;EACnB,iBAAiB,EAAE,6BAA6B;EAChD,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB,CAAC;;IAEG,WAAW;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW,EAAE,wBAAwB;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,8CAA8C;AAC7D;;AAEA;EACE,SAAS,EAAE,4BAA4B;EACvC,mBAAmB;EACnB,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA;EACE,YAAY,EAAE,qCAAqC;EACnD,kBAAkB,EAAE,mBAAmB;AACzC;AACA;EACE,YAAY,EAAE,qCAAqC;EACnD,kBAAkB,EAAE,mBAAmB;EACvC,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;IACI,iBAAiB;AACrB;AACA;EACE,aAAa,QAAQ,2BAA2B;EAChD,mBAAmB;EACnB,uBAAuB,EAAE,sBAAsB;EAC/C,QAAQ,aAAa,mCAAmC;EACxD,kBAAkB;EAClB,WAAW,EAAE,wCAAwC;AACvD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uDAAuD;EACvD,kBAAkB,GAAG,4CAA4C;EACjE,mBAAmB;EACnB,cAAc,EAAE,qCAAqC;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB,GAAG,yBAAyB;EAC9C,MAAM;EACN,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,aAAa,QAAQ,mBAAmB;AAC1C;;AAEA;EACE,UAAU;EACV,WAAW,UAAU,eAAe;AACtC;;AAEA,qDAAqD;AACrD;EACE,aAAa,EAAE,8BAA8B;AAC/C;;AAEA;EACE,aAAa,EAAE,yBAAyB;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kFAAkF;EAClF,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA,yCAAyC;EACzC;IACE,aAAa,EAAE,kCAAkC;EACnD;EACA;IACE,mBAAmB,EAAE,iCAAiC;EACxD;EACA;IACE,cAAc,EAAE,yBAAyB;EAC3C;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,OAAO,aAAa,EAAE,UAAU,EAAE;EAClC,KAAK,kBAAkB,EAAE,UAAU,EAAE;AACvC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,4BAA4B;;AAE9B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;AAE/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;AACF;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,wCAAwC;AAC1C;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;;;GAGG;AACH,+CAA+C;AAC/C;;EAEE,aAAa;AACf;;AAEA,iCAAiC;AACjC;;EAEE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,OAAO;AACT;AACA;;;;GAIG;AACH;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA,yDAAyD;AACzD;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;;EAEE,kBAAkB,EAAE,8DAA8D;EAClF,wCAAwC;EACxC,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,gDAAgD;EAChD;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,YAAY,EAAE,2BAA2B;IACzC,uBAAuB,EAAE,4BAA4B;EACvD;EACA;IACE,WAAW,EAAE,yCAAyC;IACtD,kBAAkB;EACpB;EACA,6DAA6D;EAC7D;IACE,cAAc,EAAE,kCAAkC;EACpD;EACA,4CAA4C;EAC5C;IACE,aAAa;EACf;EACA,+CAA+C;EAC/C;IACE,gBAAgB,EAAE,mBAAmB;EACvC;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/**\n * OHT Weather Widget - React Version\n * Main stylesheet\n */\n\n.oht-weather-widget {\n  font-family: Arial, sans-serif;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2px;\n  color: #333;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  background-color: #fff;\n  padding-bottom: 43px;\n}\n\n.oht-weather-widget.no-border {\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n/* Loading State */\n.weather-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0;\n  text-align: center;\n}\n\n.loading-spinner-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 150px; /* Give it some height so spinner is visible */\n  width: 100%;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #000; /* Black spinner */\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Weather Header */\n.weather-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #eee;\n  margin-top: 5px;\n  padding-left: 10px;\n  padding-right: 4px;\n}\n\n.weather-header-link {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n}\n\n.location {\n  display: flex;\n  align-items: center;\n}\n\n.location h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.location-pin {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  color: #000000;\n  margin-top:-5px;\n}\n\n.weather-search form {\n  display: flex;\n}\n\n.weather-search input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px 0 0 4px;\n  font-size: 14px;\n}\n\n.weather-search button {\n  padding: 8px 12px;\n  background-color: #000000;\n  color: white;\n  border: none;\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.weather-search button:hover {\n  background-color: rgb(42, 42, 42);\n}\n\n/* Current Weather */\n.current-weather {\n  display: flex; /* Use flex */\n  flex-wrap:wrap;\n  gap: 20px; /* Gap between columns */\n  align-items: flex-start; /* Align items to the top */\n  margin-bottom: 20px;\n  padding: 20px;\n  border-radius: 8px;\n}\n.weather-content{\n  padding:3px;\n}\n.current-weather-container{\n  flex: 1 1 300px;\n}\n\n/* Style the top part (icon + temp/condition) */\n.current-weather-top {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 28px;\n}\n\n/* Larger main weather icon */\n.current-weather-top > .weather-icon.large-icon {\n  font-size: 84px; /* Make icon larger */\n  padding-left: 20px\n}\n\n.temp-condition {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Align text left */\n  text-align: left;\n  margin-left: 41px;\n}\n\n/* New style for RIGHT NOW label */\n.right-now-label {\n  font-size: 12px;\n  font-weight: bold;\n  color: #666;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n}\n\n.temperature {\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1;\n  display: flex; /* Align icon and temp */\n  align-items: center;\n}\n\n.condition {\n  font-size: 18px;\n  margin-top: 5px;\n  color: #666;\n}\n\n.weather-details {\n  display: grid; /* Use grid for two columns */\n  grid-template-columns: 1fr 1fr; /* Two equal columns */\n  gap: 5px 20px; /* Row gap, Column gap */\n}\n\n.detail-item {\n  display: flex; /* Label and value side-by-side */\n  justify-content: space-between; /* Push label and value apart */\n  align-items: center;\n  min-width: 0; /* Allow shrinking */\n  padding-bottom: 5px;\n  border-bottom: 1px solid #eee; /* Add border below each item */\n}\n.detail-item:nth-last-child(-n+2) { /* Remove border from last row */\n  border-bottom: none;\n}\n\n.detail-label {\n  font-size: 14px; /* Slightly smaller label */\n  color: #333;\n  margin-bottom: 0;\n  margin-right: 10px; /* Space between label and value */\n  font-weight: bold; /* Make label bold */\n}\n.today-forecast-box {\n  border-radius: 8px;\n  padding: 16px;\n  margin-top: 5px;\n  margin-left: 10px;\n  border-left: 1px solid #eee;\n  flex: 1 1 300px;\n}\n\n.today-forecast-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.today-forecast-description {\n  font-size: 14px;\n  margin-bottom: 16px;\n  color: #555;\n  line-height: 1.4;\n}\n\n.today-forecast-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tonight-forecast,\n.tomorrow-forecast {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.forecast-period {\n  font-weight: 600;\n  font-size: 15px;\n  color: #444;\n}\n\n.forecast-text {\n  font-size: 14px;\n  color: #555;\n  line-height: 1.4;\n}\n.detail-value {\n  font-size: 14px; /* Match label size */\n  font-weight: normal; \n  text-align: right; /* Align value to the right */\n  white-space: nowrap; /* Prevent wrapping */\n}\n\n/* Weather Tabs */\n.weather-tabs {\n  margin-top: 20px;\n}\n\n.tab-buttons {\n  display: flex;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 15px;\n}\n\n.tab-buttons button {\n  padding: 10px 20px;\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s, border-bottom 0.2s;\n  color: #000;\n}\n\n.tab-buttons button.active {\n  opacity: 1;\n  border-bottom: 3px solid #0066cc;\n  font-weight: 600;\n}\n\n.tab-buttons button:hover {\n  opacity: 0.9;\n}\n\n.tab-content {\n  animation: fadeIn 0.3s ease-in;\n  display: block;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Hourly Forecast */\n.hourly-heading {\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: normal;\n}\n\n.hourly-forecast-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.hourly-forecast-table th {\n  text-align: left;\n  padding: 10px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #000;\n  border-bottom: 1px solid #eee;\n  text-transform: uppercase;\n}\n.hourly-forecast-table tr {\n  border-bottom: 1px solid #eee;\n}\n.hourly-forecast-table td {\n  padding: 12px 10px;\n}\n.hourly-forecast-table tr:hover {\n  background-color: #f5f9ff;\n}\n\n.detail-btn {\n  text-align: right;\n}å\n.detail-circle i{\n    color: #000;\n}\n.detail-circle {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  color:#000;\n  border: none;\n  background-color: #f5f5f5;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.detail-circle:hover {\n  background-color: #e5e5e5;\n}\n\n/* 7 Day Forecast */\n.seven-day-forecast-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n\n.seven-day-forecast-table th {\n  text-align: center;\n  padding: 10px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #000;\n  border-bottom: 1px solid #eee;\n}\n\n.seven-day-forecast-table td {\n  padding: 12px 10px;\n  border-bottom: 1px solid #eee;\n}\n.seven-day-forecast-table tr:hover {\n  background-color: #f5f9ff;\n}\n\n.seven-day-forecast-table td.day-name {\n  width: 60px; /* Narrower day column */\n  white-space: nowrap;\n}\n\n.seven-day-forecast-table td.temp-range {\n  width: auto; /* Allow temp column to take remaining space */\n}\n\n.seven-day-forecast-table td.detail-btn {\n  width: 1%; /* Make last column narrow */\n  white-space: nowrap;\n  text-align: right; /* Align button to the right */\n}\n\n.seven-day-forecast-table td.precip {\n  width: 100px; /* Narrower precip and icon columns */\n  text-align: center; /* Center content */\n}\n.seven-day-forecast-table td.weather-icon {\n  width: 150px; /* Narrower precip and icon columns */\n  text-align: center; /* Center content */\n  font-size: 24px;\n}\n.day-name {\n  font-weight: 600;\n}\n\n.weather-icon {\n  text-align: center;\n}\n\n.icon-container {\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.precip i {\n    margin-right: 5px;\n}\n.temp-bar {\n  display: flex;       /* Use flex for alignment */\n  align-items: center; \n  justify-content: center; /* Center the slider */\n  gap: 5px;            /* Add small gap between elements */\n  position: relative;  \n  width: 100%; /* Ensure bar takes full width of cell */\n}\n\n.temp-slider {\n  /* No flex needed */\n  height: 28px;\n  background: linear-gradient(to right, #d9e7f3, #5a8db6);\n  position: relative;  /* Position relative for absolute children */\n  border-radius: 11px;\n  margin: 0 auto; /* Center the slider within the bar */\n}\n\n.low-temp, .high-temp {\n  font-size: 14px;\n  font-weight: 600;\n  position: absolute;  /* Absolute positioning */\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  z-index: 1;\n}\n\n.low-temp {\n  left: 8px;\n  color:#042743;       /* Dark blue text */\n}\n\n.high-temp {\n  right: 8px;\n  color: #fff;         /* White text */\n}\n\n/* Mobile-specific temp display - hidden by default */\n.temp-range-mobile {\n  display: none; /* Hide this cell by default */\n}\n\n.temp-text-mobile {\n  display: none; /* Hide text by default */\n  font-size: 14px;\n  font-weight: 600;\n  color: #042743;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* Weather Map */\n.map-tab {\n  position: relative;\n}\n\n.radar-controls {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.radar-locations button, \n.radar-layers button {\n  background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 12px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.radar-locations button:hover,\n.radar-layers button:hover {\n  background-color: #f5f5f5;\n}\n\n.radar-layers {\n  display: flex;\n  gap: 5px;\n}\n\n.weather-map {\n  width: 100%;\n  background-color: #f0f0f0;\n  border-radius: 4px;\n  position: relative;\n}\n\n.map-loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.7);\n  font-size: 16px;\n  color: #666;\n}\n\n.map-timestamp {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n  font-size: 12px;\n  color: #888;\n}\n\n.map-legend {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n}\n\n.legend-scale {\n  width: 100px;\n  height: 10px;\n  background: linear-gradient(to right, #0066ff, #00ff00, #ffff00, #ff9900, #ff0000);\n  border-radius: 2px;\n}\n\n.legend-labels {\n  width: 100px;\n  display: flex;\n  justify-content: space-between;\n}\n\n/* Weather Detail Modal */\n.weather-detail-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n}\n\n.modal-header {\n  padding: 16px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n}\n\n.close-button:hover {\n  color: #000;\n}\n\n.modal-body {\n  padding: 16px;\n}\n\n.detail-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.detail-summary {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.detail-temps {\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.detail-temps .high {\n  color: #d9534f;\n  font-weight: bold;\n}\n\n.detail-temps .low {\n  color: #5bc0de;\n  font-weight: bold;\n  margin-top: 4px;\n}\n\n.detail-condition {\n  flex: 1;\n  min-width: 200px;\n}\n\n.detail-condition h4 {\n  margin: 0 0 8px 0;\n  color: #333;\n}\n\n.detail-condition p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.detail-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.detail-section {\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.detail-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  color: #444;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 4px;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n\n.detail-row .label {\n  color: #666;\n}\n\n.detail-row .value {\n  font-weight: 500;\n  color: #333;\n}\n\n.detail-day-night {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.detail-day-night .day,\n.detail-day-night .night {\n  flex: 1;\n  min-width: 200px;\n}\n\n.detail-day-night .day h4 {\n  color: #f0ad4e;\n}\n\n.detail-day-night .night h4 {\n  color: #5bc0de;\n}\n\n.detail-section.astro .detail-row {\n  margin-bottom: 8px;\n}\n\n@media (max-width: 600px) {\n  .modal-content {\n    width: 95%;\n  }\n  \n  .detail-summary {\n    flex-direction: column;\n  }\n  \n  .detail-day-night {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .detail-row {\n    font-size: 13px;\n  }\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .oht-weather-widget {\n    padding: 11px;\n  }\n  \n  .current-weather {\n    gap: 20px;\n  }\n  \n  .weather-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .weather-search form {\n    width: 100%;\n  }\n  \n  .weather-search input {\n    flex: 1;\n  }\n  \n  .today-forecast-details {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .tonight-forecast, .tomorrow-forecast {\n    width: 100%;\n  }\n  \n  .tab-buttons button {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n  \n  .detail-row {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .detail-item {\n    flex-direction: row;\n    justify-content: space-between;\n    min-width: auto;\n  }\n\n  /* Show mobile temp text, hide temp bar */\n  .seven-day-forecast-table td.temp-range {\n    display: none; /* Hide original temp bar column */\n  }\n  .seven-day-forecast-table td.temp-range-mobile {\n    display: table-cell; /* Show mobile temp text column */\n  }\n  .seven-day-forecast-table .temp-text-mobile {\n    display: block; /* Show the mobile text */\n  }\n  .today-forecast-box{\n    margin-left: 0px;\n    border-left: unset;\n    padding: 0px;\n  }\n}\n\n/* 7 Day Forecast Expandable Rows */\n.seven-day-forecast-table tr.expanded-row {\n  background-color: #f5f9ff;\n}\n\n.seven-day-forecast-table .detail-circle.expanded svg {\n  transform: rotate(90deg);\n}\n\n.seven-day-forecast-table .detail-circle svg {\n  transition: transform 0.3s ease;\n}\n\n.details-row {\n  background-color: #f5f9ff;\n}\n\n.day-details {\n  padding: 15px;\n  animation: slideDown 0.3s ease-in-out;\n  overflow: hidden;\n}\n\n@keyframes slideDown {\n  from { max-height: 0; opacity: 0; }\n  to { max-height: 1000px; opacity: 1; }\n}\n\n.day-details-header {\n  margin-bottom: 10px;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 5px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.day-details-header h3 {\n  margin: 0;\n  font-size: 16px;\n  color: #444;\n}\n\n.forecast-narrative {\n  margin: 5px 0;\n  font-size: 14px;\n  font-style: italic;\n  color: #666;\n  line-height: 1.4;\n}\n\n.day-details-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n}\n\n/* New grid layout for weather stats */\n.weather-stats-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 15px;\n}\n\n.stat-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  flex: 1;\n  min-width: 250px;\n}\n\n.stat-box {\n  display: flex;\n  flex-direction: column;\n  min-width: 100px;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 5px;\n  border-left: 3px solid #4dabf7;\n}\n\n.stat-box:nth-child(2) {\n  border-left-color: #fd7e14;\n}\n\n.stat-box:nth-child(3) {\n  border-left-color: #20c997;\n}\n\n.stat-box:nth-child(4) {\n  border-left-color: #7950f264;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #6c757d;\n  margin-bottom: 4px;\n}\n\n.stat-value {\n  font-size: 15px;\n  font-weight: 500;\n  color: #343a40;\n}\n\n.high-value {\n  color: #e03131;\n}\n\n.low-value {\n  color: #1971c2;\n}\n\n/* Day/Night section */\n.day-night-container {\n  margin-top: 10px;\n  background-color: white;\n  border-radius: 6px;\n  padding: 15px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.section-title {\n  margin: 0 0 12px 0;\n  font-size: 15px;\n  color: #495057;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.day-night-columns {\n  display: flex;\n  gap: 20px;\n}\n\n.time-column {\n  flex: 1;\n  padding: 10px 15px;\n  border-radius: 5px;\n  background-color: #f8f9fa;\n}\n\n.day-column {\n  border-left: 3px solid #fd7e14;\n}\n\n.night-column {\n  border-left: 3px solid #1971c2;\n}\n\n.time-column h5 {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.day-column h5 {\n  color: #fd7e14;\n}\n\n.night-column h5 {\n  color: #1971c2;\n}\n\n.time-details {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.time-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.detail-temp {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.detail-condition {\n  font-size: 13px;\n  color: #495057;\n}\n\n.mini-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 5px;\n}\n\n.mini-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background-color: white;\n  padding: 5px 8px;\n  border-radius: 4px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n  min-width: 70px;\n}\n\n.mini-label {\n  font-size: 11px;\n  color: #6c757d;\n}\n\n.mini-value {\n  font-size: 13px;\n  font-weight: 500;\n  color: #343a40;\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n  .weather-stats-grid {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .day-night-columns {\n    flex-direction: column;\n    gap: 15px;\n  }\n}\n\n/* Condensed weather stats for 7-day forecast */\n.weather-stats-condensed {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 16px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  min-width: 100px;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #666;\n  font-weight: 500;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.stat-value {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.mini-stats-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.mini-stat {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 14px;\n  color: #555;\n}\n\n/* New detailed day layout */\n.day-details-grid {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.day-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.day-icon {\n  margin-bottom: 5px;\n}\n\n.large-icon {\n  font-size: 48px;\n}\n\n.day-temps {\n  display: flex;\n  align-items: center;\n  font-size: 36px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.day-high-temp {\n  color: #000;\n}\n\n.day-low-temp {\n  color: #666;\n  font-size: 28px;\n}\n\n.day-narrative {\n  font-size: 14px;\n  color: #555;\n  line-height: 1.4;\n  margin-top: 10px;\n}\n\n.weather-details-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-item-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 8px;\n}\n\n.detail-item-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.detail-item-value {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.night-forecast-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 5px;\n}\n\n.night-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.night-description {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #444;\n}\n\n@media (max-width: 650px) {\n  .day-details-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .day-summary {\n    margin-bottom: 20px;\n  }\n}\n\n/* Two-column layout for weather details */\n.details-two-column {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.details-column {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n@media (max-width: 450px) {\n  .details-two-column {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}\n\n/* Hourly forecast styling update */\n.hourly-temp {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  font-size: 20px;\n}\nthead{\n  background-color: ghostwhite;\n\n}\n\n.hourly-icon {\n  font-size: 22px;\n  margin-right: 5px;\n}\n\n.hourly-wind {\n  text-align: left;\n  white-space: nowrap;\n}\n\n.hourly-wind i {\n  font-size: 22px;\n  color: #555;\n  margin-right: 5px;\n}\n\n.hourly-precip {\n  white-space: nowrap;\n}\n\n.hourly-precip i {\n  margin-right: 5px;\n}\n\n/* Hourly Forecast Expandable Details */\n.hourly-forecast-table tr.expanded-row {\n  background-color: #f5f9ff;\n}\n\n.hourly-forecast-table .detail-circle.expanded i {\n  transform: rotate(90deg);\n}\n\n.hourly-forecast-table .detail-circle i {\n  transition: transform 0.3s ease;\n  color: #000;\n}\n\n.details-row {\n  background-color: #f9f9fa;\n}\n\n.hourly-details {\n  padding: 15px;\n  animation: slideDown 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n\n}\n\n.hourly-time-temp {\n  text-align: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n}\n\n.hourly-time {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.hourly-temp-detail {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 32px;\n}\n\n.hourly-condition-name {\n  font-size: 16px;\n  color: #666;\n}\n\n.hourly-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n  margin-bottom: 15px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  /* border: 1px solid #eee; */\n  overflow: hidden;\n}\n\n.hourly-detail-left, \n.hourly-detail-right {\n  padding: 10px 15px;\n}\n.hourly-details-right-section {\n  margin-left: 10px;\n  border-left: 1px solid #eee;\n}\n.hourly-detail-left {\n  border-right: 1px solid #eee;\n}\n\n.hourly-detail-left .detail-item-row,\n.hourly-detail-right .detail-item-row {\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border:unset;\n  /* border-bottom: 1px solid #eee; */\n}\n\n.hourly-detail-left .detail-item-row:last-child,\n.hourly-detail-right .detail-item-row:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.detail-item-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n}\n\n.detail-item-row.uv-row {\n  max-width: 250px;\n  margin: 5px auto;\n  padding: 8px 15px;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  background-color: #f8f9fa;\n}\n\n.detail-item-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.detail-item-value {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n@media (max-width: 600px) {\n  .hourly-details-grid {\n    grid-template-columns: 1fr;\n    gap: 5px;\n  }\n  \n  .hourly-details-columns {\n    flex-direction: column;\n  }\n  \n  .hourly-detail-left {\n    border-right: none;\n    border-bottom: 1px solid #eee;\n  }\n}\n\n/* Wind icon styling */\n.wi-wind {\n  font-size: 22px;\n  display: inline-block;\n}\n\n.towards-0-deg {\n  transform: rotate(0deg);\n} \n\n.leaflet-attribution-flag{\n  display: none !important;\n}\n\n/* Weather Alerts Styles */\n.weather-alerts-container {\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n/* Alert banner styling to match the red warning banner in the screenshot */\n.weather-alert {\n  background-color: #ffffff;\n  border-radius: 4px;\n  margin-bottom: 5px;\n  overflow: hidden;\n  transition: box-shadow 0.3s ease;\n}\n\n.weather-alert:first-child {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.weather-alert:last-child {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  margin-bottom: 0;\n}\n\n.weather-alert .alert-header {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  position: relative;\n}\n\n.weather-alert:first-child .alert-header {\n  background-color: #c41e3a;\n  color: white;\n}\n\n.weather-alert:first-child .alert-headline {\n  color: white;\n  font-weight: 700;\n}\n\n.weather-alert .alert-icon {\n  margin-right: 12px;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.weather-alert .alert-headline {\n  flex-grow: 1;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.weather-alert .alert-toggle {\n  margin-left: 8px;\n  font-size: 12px;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.weather-alert .alert-details {\n  padding: 0 16px 16px;\n  background-color: #f8f9fa;\n  font-size: 14px;\n  line-height: 1.5;\n  border-top: 1px solid #eee;\n}\n\n.weather-alert .alert-meta {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  font-size: 13px;\n  color: #666;\n}\n\n.weather-alert .alert-instructions h4,\n.weather-alert .alert-description h4 {\n  margin: 0 0 8px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.weather-alert .alert-instructions p,\n.weather-alert .alert-description p {\n  margin: 0 0 16px;\n  white-space: pre-line;\n}\n\n.weather-alert .alert-timing {\n  font-size: 12px;\n  color: #666;\n  padding-top: 12px;\n  border-top: 1px solid #eee;\n}\n\n.weather-alert .alert-timing p {\n  margin: 4px 0;\n}\n\n/* Animation for expanded alert */\n.weather-alert.expanded {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Winter storm watch specific styling to match screenshot */\n.weather-alert[data-alert-type=\"winter-storm-watch\"] .alert-header {\n  background-color: #c41e3a;\n  color: white;\n}\n.oht-sidebar .oht-weather-widget .oht-weather-container.in-widget .weather-content{\n  padding: 0;\n}\n\n/* .oht-sidebar .oht-weather-widget .hourly-forecast-table th:last-child,\n.oht-sidebar .oht-weather-widget .hourly-forecast-table td:last-child{\n  display: none;\n} */\n/* hide wind icon column .hourly-forecasttable*/\n.oht-sidebar .oht-weather-widget .hourly-forecast-table th:nth-child(3),\n.oht-sidebar .oht-weather-widget .hourly-forecast-table td:nth-child(3){\n  display: none;\n}\n\n/* for 7 day hide precip column */\n.oht-sidebar .oht-weather-widget .seven-day-forecast-table th:nth-child(3),\n.oht-sidebar .oht-weather-widget .seven-day-forecast-table td:nth-child(3){\n  display: none;\n}\n.oht-sidebar .details-row .hourly-details, .oht-sidebar .details-row .day-details-content{\n  display:grid;\n}\n.oht-sidebar .detail-circle{\n  width:0px;\n}\n.oht-sidebar .hourly-details{\n  padding: 0px;\n  justify-content: unset;\n}\n.oht-sidebar .hourly-detail-left{\n  border:unset;\n  padding:0px;\n}\n.oht-sidebar .hourly-detail-right{\n  padding:0px;\n  border:unset;\n}\n.oht-sidebar .hourly-details-right-section{\n  border:unset;\n  margin-right:10px;\n}\n.oht-sidebar .details-row .hourly-details-grid, .oht-sidebar .details-row .day-details-grid{\n  grid-template-columns: 1fr;\n  border:unset;\n  gap:0px;\n}\n/* for 7 day hide last column\n.oht-sidebar .oht-weather-widget .seven-day-forecast-table th:last-child,\n.oht-sidebar .oht-weather-widget .seven-day-forecast-table td:last-child{\n  display: none;\n} */\n.oht-sidebar .today-forecast-box {\n  border-radius: 8px;\n  padding: 0px;\n  margin:0px;\n  border:unset;\n}\n.oht-sidebar .details-two-column{\n  grid-template-columns: 1fr;\n}\n/* Show mobile temp text, hide temp bar in .oht-sidebar */\n.oht-sidebar .seven-day-forecast-table td.temp-range {\n  display: none; \n}\n.oht-sidebar .seven-day-forecast-table td.temp-range-mobile {\n  display: table-cell; \n}\n.oht-sidebar .seven-day-forecast-table .temp-text-mobile {\n  display: block; \n}\n.oht-sidebar .current-weather{\n  padding: 2px;\n}\n.oht-sidebar .weather-details{\n  gap: 5px 12px;\n}\n.oht-sidebar .oht-weather-widget {\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n.wi {\n  font-weight: bold!important;\n}\n\n/* Ensure tab content allows centering */\n.tab-content.hourly-tab,\n.tab-content.forecast-tab {\n  position: relative; /* Needed for absolute centering of spinner if used directly */\n  /* Add padding or min-height if needed */\n  padding: 20px;\n}\n\n/* Hide timeline controls on small screens */\n@media (max-width: 500px) {\n  /* Hide only the slider, keep the time display */\n  .time-slider {\n    display: none;\n  }\n  .timeline-container {\n    /* Adjust layout now that slider is gone */\n    flex-grow: 1; /* Allow it to take space */\n    justify-content: center; /* Center the time display */\n  }\n  .time-display {\n    width: auto; /* Allow time display to size naturally */\n    text-align: center;\n  }\n  /* Optional: Adjust spacing of remaining controls if needed */\n  .radar-controls.bottom-bar .timeline-controls {\n    margin: 0 auto; /* Center play/prev/next buttons */\n  }\n  /* Hide only the text in the layers button */\n  .layers-btn-text {\n    display: none;\n  }\n  /* Adjust button padding if icon looks lonely */\n  .radar-controls.bottom-bar .layers-btn {\n    padding: 6px 8px; /* Reduce padding */\n  }\n  .tab-content.hourly-tab, .tab-content.forecast-tab {\n    padding: 0px;\n  }\n  .tab-content.map-tab {\n    margin-bottom: 42px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
